import { styled } from '@mui/material';

import { colors, fontWeight } from '~/styles/constants';

interface LinkProps {
  children?: React.ReactNode;
  className?: string;
  // This will also set data-testid
  dataAnalytics?: string;
  dataE2E?: string;
  dataHeap?: string;
  dataPendo?: string;
  disabled?: boolean; // if true, the Link's color and text-decoration styling will be overridden to the disabled styling
  hideUnderline?: boolean;
  href?: string;
  id?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  rel?: string;
  tabIndex?: number;
  target?: string;
}

const LinkComponent = styled('a')<LinkProps>`
  font-size: inherit;
  cursor: pointer;
  text-decoration: ${(props) => (props.hideUnderline ? 'none' : 'normal')};
  ${(props) =>
    props.disabled
      ? `color: ${colors.gray400} !important;
    cursor: not-allowed;
    text-decoration: none !important;`
      : ''}
`;

const Link = (props: LinkProps) => {
  const {
    children,
    className,
    dataAnalytics,
    dataE2E,
    dataHeap,
    dataPendo,
    disabled,
    hideUnderline,
    href,
    id,
    onClick,
    rel,
    tabIndex,
    target,
  } = props;
  const elementProps = {
    href,
    id,
    rel,
    target,
  };

  return (
    <LinkComponent
      {...elementProps}
      className={className}
      data-analytics={dataAnalytics}
      data-e2e={dataE2E}
      data-heap={dataHeap}
      data-heap-event={dataAnalytics}
      data-pendo={dataPendo}
      data-testid={dataAnalytics}
      disabled={disabled}
      hideUnderline={hideUnderline}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      {children}
    </LinkComponent>
  );
};

export default Link;

export const GreenLink = styled(Link)`
  color: ${colors.primary};
`;

export const BlueLink = styled(Link)`
  color: ${colors.aqua};
`;

export const DeepBlueLink = styled(Link)`
  color: ${colors.forest700};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    text-decoration: underline;
  }
`;

export const DeepBlueBoldLink = styled(DeepBlueLink)`
  font-size: 0.875rem;
  font-weight: ${fontWeight.medium};
`;

export const GreyLink = styled(Link)`
  color: ${colors.secondary};
`;

export const EditLink = styled(GreyLink)`
  font-weight: ${fontWeight.normal};
  text-decoration: underline;
`;

export const LearnMoreLink = styled(Link)`
  color: ${colors.primaryAlternative};
`;

export const DangerLink = styled(Link)`
  color: ${colors.ruby700};
`;
